export const ACTIONS = {
  UPDATE_EMPLOYEE: "UPDATE_EMPLOYEE",
  GET_EMPLOYEE_WORK_SCHEDULE: "GET_EMPLOYEE_WORK_SCHEDULE",
  GET_EMPLOYEE_WORK_SCHEDULES: "GET_EMPLOYEE_WORK_SCHEDULES",
  UPDATE_EMPLOYEE_WORK_SCHEDULE: "UPDATE_EMPLOYEE_WORK_SCHEDULE",
  DELETE_EMPLOYEE_WORK_SCHEDULE: "DELETE_EMPLOYEE_WORK_SCHEDULE",
  CREATE_EMPLOYEE_WORK_SCHEDULE: "CREATE_EMPLOYEE_WORK_SCHEDULE",
  GET_WORK_SCHEDULE_DEFINITIONS: "GET_WORK_SCHEDULE_DEFINITIONS",

  GET_WORK_SCHEDULE_OVERRIDES: "GET_WORK_SCHEDULE_OVERRIDES",
  CREATE_WORK_SCHEDULE_OVERRIDE: "CREATE_WORK_SCHEDULE_OVERRIDE",
  UPDATE_WORK_SCHEDULE_OVERRIDE: "UPDATE_WORK_SCHEDULE_OVERRIDE",
  DELETE_WORK_SCHEDULE_OVERRIDE: "DELETE_WORK_SCHEDULE_OVERRIDE",
  UNLOAD_WORK_SCHEDULE_OVERRIDES: "UNLOAD_WORK_SCHEDULE_OVERRIDES",
  SHOW_EMPLOYEE_IN_PLANNER: "SHOW_EMPLOYEE_IN_PLANNER",
  HIDE_EMPLOYEE_IN_PLANNER: "HIDE_EMPLOYEE_IN_PLANNER",

  EMPLOYEE_STAY_ON_LOAD: "EMPLOYEE_STAY_ON_LOAD",
  QUERY_EMPLOYEE_WORK_SCHEDULE: "QUERY_EMPLOYEE_WORK_SCHEDULE",
  QUERY_EMPLOYEE_WORK_SCHEDULES: "QUERY_EMPLOYEE_WORK_SCHEDULES",

  EMPLOYEE_CALENDAR_ON_LOAD: "EMPLOYEE_CALENDAR_ON_LOAD",

  ASSIGN_PROJECT_TO_EMPLOYEE: "ASSIGN_PROJECT_TO_EMPLOYEE",
  UNASSIGN_PROJECT_TO_EMPLOYEE: "UNASSIGN_PROJECT_TO_EMPLOYEE",
  GET_EMPLOYEES_PROJECTS: "GET_EMPLOYEES_PROJECTS",
};

export const UPDATE_EMPLOYEE_FORM = {
  ID: "updateEmployee",
  EMPLOYEE_NUMBER: "employeeNumber",
  DISPLAY_NAME: "displayName",
  ADDRESS: "address",
  ZIP_CODE: "zipCode",
  CITY: "city",
  PHONE: "phone",
  CELL_PHONE: "cellPhone",
  EMAIL_WORK: "emailWork",
  EMAIL_PRIVATE: "emailPrivate",
  NATIONALITY: "nationality",
  WORK_LOCATION: "workLocation",
  JOB_TITLE: "jobTitle",
  DEPARTMENT_CODE: "departmentCode",
  DEPARTMENT_NAME: "departmentName",
  DATE_OF_BIRTH: "dateOfBirth",
  HIRED_FROM: "hiredFrom",
  HIRED_TO: "hiredTo",
  NEXT_OF_KIN_NAME: "nextOfKin.displayName",
  NEXT_OF_KIN_ADDRESS: "nextOfKin.address",
  NEXT_OF_KIN_ZIP_CODE: "nextOfKin.zipCode",
  NEXT_OF_KIN_CITY: "nextOfKin.city",
  NEXT_OF_KIN_PHONE1: "nextOfKin.phone1",
  NEXT_OF_KIN_PHONE2: "nextOfKin.phone2",
  NEXT_OF_KIN_TYPE: "nextOfKin.type",
  TRAVEL_AIRPORT: "travel.airport",
  TRAVEL_DA_WINCI: "travel.daWinci",
  TRAVEL_TICKET: "travel.ticket",
  TRAVEL_VANTAGE: "travel.vantage",
  QUALIFICATION: "qualificationId",
  EMPLOYEE_GROUP: "employeeGroupId",
  MARKERS: "markers",
  NOTES: "notes",

  SHIFT: "shift",
  NEXT_DEPARTURE: "nextDeparture",
};

export const WORK_SCHEDULE_FORM = {
  ID: "createWorkSchedule",
  ROTATIONS: "rotationTimes",
  DEFINITION: "workScheduleDefinitionId",
  START_DATE: "startDate",
  END_DATE: "endDate",
  EMPLOYEE: "employeeId",
  CARD_ID: "cardId",
};

export const CREATE_WORK_SCHEDULE_MODAL_ID = "CREATE_WORK_SCHEDULE";
export const EDIT_WORK_SCHEDULE_MODAL_ID = "EDIT_WORK_SCHEDULE";
export const SIMPLE_EDIT_WORK_SCHEDULE_MODAL_ID = "SIMPLE_EDIT_WORK_SCHEDULE";
export const DEPLOYMENT_DETAILS_MODAL_ID = "DEPLOYMENT_DETAILS";

export const CREATE_WORK_SCHEDULE_OVERRIDE_MODAL_ID =
  "CREATE_WORK_SCHEDULE_OVERRIDE_MODAL_ID";
export const EDIT_WORK_SCHEDULE_OVERRIDE_MODAL_ID =
  "EDIT_WORK_SCHEDULE_OVERRIDE_MODAL_ID";

export const WORK_SCHEDULE_OVERRIDE_FORM = {
  ID: "workScheduleOverride",
  CARD_ID: "cardId",
  REASON: "overrideReason",
  NOTES: "notes",
  START_DATE: "startDate",
  END_DATE: "endDate",
};

// special hash target to signal that the employee container was opened in its own window
export const EMPLOYEE_CARD_HASH_TARGET = "#window";
